import React from 'react';
import { Stack, Switch, Divider } from '@mantine/core';
import type { PanelConfig, CarouselConfig } from '../../data/DeviceConfig';
import CarouselEditor from './CarouselEditor';

interface PanelConfigEditorProps {
    panel: PanelConfig;
    onChange: (panel: PanelConfig) => void;
}

export const DEFAULT_PANEL: PanelConfig = {
    commercialTakeover: false,
    content: [],
    commercialContent: [],
};

const PanelConfigEditor: React.FC<PanelConfigEditorProps> = ({ panel, onChange }) => {
    const handleContentChange = (content: CarouselConfig) => onChange({ ...panel, content });
    const handleCommercialContentChange = (commercialContent: CarouselConfig) =>
        onChange({ ...panel, commercialContent });

    return (
        <Stack gap="md">
            <Switch
                label="Commercial Takeover"
                description="When enabled, commercial content immediately replaces regular content during commercial breaks."
                checked={panel.commercialTakeover}
                onChange={e => onChange({ ...panel, commercialTakeover: e.currentTarget.checked })}
            />

            <Divider />

            <CarouselEditor
                label="Content"
                items={panel.content}
                onChange={handleContentChange}
            />

            <Divider />

            <CarouselEditor
                label="Commercial Content"
                items={panel.commercialContent}
                onChange={handleCommercialContentChange}
            />
        </Stack>
    );
};

export default PanelConfigEditor;
